import axios from 'axios';
import {modal} from '../../modal-template/modal-template';
import {filter} from "../../filter/filter";

const DATA_ATTR = 'data-troika-available';
const CLASS_PREFIX = 'troika-available';


export function initTroikaAvailable($container) {
    const $templateMain = document.querySelector(`[${DATA_ATTR}-template-main]`);
    const $templateEmpty = document.querySelector(`[${DATA_ATTR}-template-empty]`);
    const $templateCard = document.querySelector(`[${DATA_ATTR}-template-card]`);
    const $templateList = document.querySelector(`[${DATA_ATTR}-template-list]`);

    let $componentContainer = null;
    let $groupCount = null;
    let $contentContainer = null;
    let $filtersContainer = null;
    let $loader = null;

    let currentSkip = 0;
    let currentTake = 50;
    let totalCount = 0;

    let currentFilters = {};
    const filtersData = [
        {
            entity: 'Темы',
            meta: 'university_themes',
            items: [
                { id: 1, name: 'Тема 1' },
                { id: 2, name: 'Тема 2' },
                { id: 3, name: 'Тема 3' },
                { id: 4, name: 'Тема 4' },
                { id: 5, name: 'Тема 5' },
                { id: 6, name: 'Тема 6' },
            ]
        },
        {
            entity: 'Роли',
            meta: 'university_roles',
            items: [
                { id: 1, name: 'Группа 1' },
                { id: 2, name: 'Группа 2' },
                { id: 3, name: 'Группа 3' },
                { id: 4, name: 'Группа 4' },
                { id: 5, name: 'Группа 5' },
                { id: 6, name: 'Группа 6' },
            ]
        }
    ];
    const troikaData = [
        {
            name: 'Тройка 1',
            roles: [
                {name: 'Интервизор', is_find: true, is_you: false},
                {name: 'Клиент', is_find: true, is_you: true}]
        },
        {
            name: 'Тройка 2',
            roles: [{name: 'Интервизор', is_find: true, is_you: true},
                {name: 'Клиент', is_find: false, is_you: false}]
        },
        {
            name: 'Тройка 3',
            roles: [{name: 'Интервизор', is_find: true, is_you: false},
                {name: 'Клиент', is_find: true, is_you: false}]
        },
    ];

    init();
    async function init() {
        console.log('$templateMain', $templateMain)
        if (!$templateMain) return;
        await renderMain();
        fetchGroups();
    }

    function fetchGroups() {
        $loader.style.display = 'none';
        renderList(troikaData, 3);
    }

    function renderMain() {
        const $mainFragment = $templateMain.content.cloneNode(true);

        $componentContainer = $mainFragment.querySelector(`[${DATA_ATTR}]`);
        $groupCount = $componentContainer.querySelector(`[${DATA_ATTR}-group-count]`);
        $contentContainer = $componentContainer.querySelector(`[${DATA_ATTR}-content]`);
        $filtersContainer = $componentContainer.querySelector(`[${DATA_ATTR}-filters]`);
        $loader = $componentContainer.querySelector(`[${DATA_ATTR}-loader]`);

        renderFilters();

        $container.appendChild($mainFragment);
        document.dispatchEvent(new CustomEvent('troika-live:render-complete', {bubbles: true}));
    }

    function renderFilters() {
        $filtersContainer.innerHTML = '';

        const itemName = (item) => {
            if (!item) return 'ID unknown';
            return item.name || item.title || (item.first_name || item.last_name ? `${item.first_name || ''} ${item.last_name || ''}`.trim() : item.email) || `ID ${item.id ?? 'unknown'}`;
        };

        filtersData.forEach(filterData => {
            const entityTitle = filterData.entity || filterData.meta || 'Фильтр';
            const metaName = filterData.meta || filterData.entity || 'unknown_meta';
            const itemsRaw = Array.isArray(filterData.items) ? filterData.items : [];

            const items = itemsRaw.map(i => ({
                id: i.id,
                name: itemName(i),
            }));

            const initialValue = Array.isArray(currentFilters[metaName]) ? currentFilters[metaName] : [];

            filter($filtersContainer, {
                type: 'list',
                filterFor: metaName,
                title: `Все ${entityTitle}`,
                name: entityTitle,
                data: items.length ? items : [],
                value: initialValue,
                modClass: `m-hide`,
                onAccept: (val) => {
                    console.log('Приняли фильтр:', metaName, val);
                },
                onClear: () => {
                    console.log('Сброс фильтра:', metaName);
                },
                onChange: (val) => {
                    console.log('Изменилось:', metaName, val);
                },
            });
        });
    }

    function renderEmpty() {
        if ($groupCount) $groupCount.textContent = '';
        $contentContainer.innerHTML = '';
        const emptyFragment = $templateEmpty.content.cloneNode(true);
        $contentContainer.appendChild(emptyFragment);
    }

    function renderList(groups, count) {
        $contentContainer.innerHTML = '';
        if ($groupCount) $groupCount.textContent = String(count);

        const $listFragment = $templateList.content.cloneNode(true);
        const $listContainer = $listFragment.querySelector(`[${DATA_ATTR}-list]`);

        groups.forEach((group, index) => {
            renderCard($listContainer, group, index);
        });

        $contentContainer.appendChild($listFragment);
    }

    function renderCard($cardList, group, index) {
        const $cardFragment = $templateCard.content.cloneNode(true);
        const $troikaRoot = $cardFragment.querySelector(`.${CLASS_PREFIX}__card`);
        const $rolesContainer = $cardFragment.querySelector(`[${DATA_ATTR}-roles]`);
        const $joinButton = $cardFragment.querySelector(`[${DATA_ATTR}-join]`);

        // для поиска/доступа позже добавим data-атрибут на корневой элемент
        if ($troikaRoot) $troikaRoot.dataset.troikaIndex = index;

        group.roles.forEach((role, roleIndex) => {
            const $role = createRoleElement(role, index, roleIndex);
            $rolesContainer.appendChild($role);
        });

        // После создания всех ролей — установим активный (первый доступный)
        const $roleElements = Array.from($rolesContainer.querySelectorAll(`.${CLASS_PREFIX}__card-control-select`));
        const firstAvailable = $roleElements.find(el => el.dataset.isFind === 'false');
        if (firstAvailable) {
            setActiveRole($rolesContainer, firstAvailable);
        } else {
            // если все заняты, оставляем без активного — но можно визуально уведомить
            $troikaRoot.classList.add(`${CLASS_PREFIX}__card--all-busy`);
        }

        // Обработчик кликов по контейнеру ролей (делегирование)
        $rolesContainer.addEventListener('click', (e) => {
            const $target = e.target.closest(`.${CLASS_PREFIX}__card-control-select`);
            if (!$target) return;
            if ($target.dataset.isFind === 'true') return; // игнорируем клики по занятым
            setActiveRole($rolesContainer, $target);
        });

        // Присоединиться — действие на кнопку (использует выбранную роль)
        $joinButton.addEventListener('click', () => {
            const $selected = $rolesContainer.querySelector(`.${CLASS_PREFIX}__card-control-select--active`);
            if (!$selected) {
                // можно показать уведомление, но оставлю простой console
                console.warn('Нет выбранной доступной роли для присоединения.');
                return;
            }
            const troikaIdx = $troikaRoot.dataset.troikaIndex;
            const roleIdx = $selected.dataset.roleIndex;
            const roleName = $selected.dataset.roleName;
            // Пример: вызов API для присоединения
            console.log(`Присоединяемся к тройке ${troikaIdx}, роль ${roleIdx} (${roleName})`);
        });

        $cardList.appendChild($cardFragment);
    }

    function createRoleElement(role, troikaIndex, roleIndex) {
        const $role = document.createElement('div');
        $role.classList.add(`${CLASS_PREFIX}__card-control-select`);
        $role.textContent = role.name;

        // dataset для удобства
        $role.dataset.troikaIndex = troikaIndex;
        $role.dataset.roleIndex = roleIndex;
        $role.dataset.roleName = role.name;
        $role.dataset.isFind = role.is_find;

        // доступность / внешний вид
        if (role.is_find) {
            $role.classList.add(`${CLASS_PREFIX}__card-control-select--disabled`);
            $role.setAttribute('aria-disabled', 'true');
            $role.tabIndex = -1;
        } else {
            $role.tabIndex = 0; // сделать доступным для клавиатуры
            $role.setAttribute('role', 'button');
            $role.setAttribute('aria-pressed', 'false');
        }

        return $role;
    }
    function setActiveRole($rolesContainer, $roleToActivate) {
        // Убираем активность у всех
        const $all = $rolesContainer.querySelectorAll(`.${CLASS_PREFIX}__card-control-select`);
        $all.forEach(el => {
            el.classList.remove(`${CLASS_PREFIX}__card-control-select--active`);
            if (el.dataset.isFind === 'false') el.setAttribute('aria-pressed', 'false');
        });

        // Устанавливаем активность на выбранном
        $roleToActivate.classList.add(`${CLASS_PREFIX}__card-control-select--active`);
        $roleToActivate.setAttribute('aria-pressed', 'true');
    }

}
